import httpClient from "Api/httpClient";

const END_POINT = "/authenticate/supervisor";

const checkOverrideCode = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.post(END_POINT, payload);
};

export { checkOverrideCode };
